<template lang="pug">
  div(
  :class="cssClass"
  @click="onOpen"
  ).route-schedule-block
    div(v-if="hasCar") {{currentCar.car.brand}} {{currentCar.car.model}}, {{currentCar.car.number}}
    route-schedule-block-update(
      :route="route"
      :cars="cars"
      v-if="openForEdit"
      :dayInfo="dayInfo"
      :day="day"
      :month="month"
      :week="week"
      :year="year"
      :dayInWeek="dayInWeek"
      :currentCar="currentCar"
      :shedules="shedules"
      @close="onClose"
    )
</template>

<script>
  import {PERIOD_DAILY, PERIOD_DAY_2, PERIOD_DAY_3, PERIOD_WEEKLY} from '../../../config/config'
  import RouteScheduleBlockUpdate from "./route-schedule-block-update";

  export default {
    name: 'route-schedule-block',
    components: {RouteScheduleBlockUpdate},
    data () {
      return {
        openForEdit: false
      }
    },
    props: {
      dayInWeek: Number,
      dayInfo: Object,
      year: '',
      week: '',
      month: '',
      day: '',
      shedules: Object,
      route: Object,
      cars: Object,
      time_range: [],
    },
    methods: {
      onOpen () {
        if (this.isActiveCell) {
          this.openForEdit = true
        }
      },
      onClose () {
        this.openForEdit = false
      }
    },
    computed: {
      sheduleId () {
        return `route_${this.route.id}_${this.year}_${this.month}_${this.day}`
      },
      currentCar () {
        if (this.shedules.hasOwnProperty(this.sheduleId)) {
          return this.shedules[this.sheduleId]
        }
        return {}
      },
      cssClass () {
        if (!this.isActiveCell) {
          return 'route-schedule-block--transp'
        }
        if (this.hasCar) {
          return 'route-schedule-block--green'
        }
        return 'route-schedule-block--red'
      },
      hasCar () {
        return this.currentCar && this.currentCar.id
      },
      isActiveCell () {
        if (!this.route) {
          return false
        }
        let day2Range = [0, 2, 4, 6]
        let day3Range = [2, 5]
        if (this.route.period_id === PERIOD_DAILY) {
          return true
        } else if (this.route.period_id === PERIOD_DAY_2 && day2Range.indexOf(this.dayInWeek) > -1) {
          return true
        } else if (this.route.period_id === PERIOD_DAY_3 && day3Range.indexOf(this.dayInWeek) > -1) {
          return true
        } else if (this.route.period_id === PERIOD_WEEKLY && this.route.weekday_id === this.dayInWeek) {
          return true
        }
        return false
      }
    }
  }
</script>
